import React, { useState, useEffect } from 'react';
import {
  Dialog,
  Box,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  TextField,
  Button,
  FormGroup,
  useTheme,
  DialogActions,
  DialogContentText,
  Slider,
  Typography,
  useMediaQuery,
  Switch,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormControl,
  FormLabel,
  Checkbox,
  FormGroup as MuiFormGroup,
  Autocomplete,
  Paper,

  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveIcon from '@mui/icons-material/Remove';
import { tokens } from "../../theme";
import { styled } from '@mui/material/styles';

import PdfThumbnail from '../../images/PdfThumbnail.png'; // import a component or image for PDF thumbnail
import GenericFileThumbnail from '../../images/GenericFileThumbnail.png'; // import a component or image for generic file thumbnail

import { collection, getDocs, where, query } from 'firebase/firestore';

import {db} from '../../firebaseConfig';

import { useUser } from "../../common/UserContext";

import { useApplicationMode } from "../../common/ApplicationModeContext";

const formatPhoneNumber = (value) => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

const formatCurrencyInteger = (value) => {
  const result = value.replace(/[^0-9]/g, '');
  if (result.length === 0) return '';
  return `$${Number(result).toLocaleString()}`;
};

const formatCurrency = (value) => {

  if (value != null && value !=="")
  {
        value = value.toString();
        // Remove all non-numeric characters except for the decimal point
        let result = value.replace(/[^0-9.]/g, '');
      
        // If there are multiple decimal points, keep only the first one
        const parts = result.split('.');
        if (parts.length > 2) {
          result = parts[0] + '.' + parts.slice(1).join('');
        }
      
        // Allow at most two decimal places
        if (parts.length === 2 && parts[1].length > 2) {
        
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
        } else if (parts.length === 2 && parts[1].length <= 2) 
        {
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        }else
        {
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return result ? `$${result}` : '';

    } else 
    {
      return "";
    }
};

const formatDecimal = (value) => {

  if (value != null && value !=="")
  {
        value = value.toString();
        // Remove all non-numeric characters except for the decimal point
        let result = value.replace(/[^0-9.]/g, '');
      
        // If there are multiple decimal points, keep only the first one
        const parts = result.split('.');
        if (parts.length > 2) {
          result = parts[0] + '.' + parts.slice(1).join('');
        }
      
        // Allow at most two decimal places
        if (parts.length === 2 && parts[1].length > 2) {
        
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
        } else if (parts.length === 2 && parts[1].length <= 2) 
        {
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        }else
        {
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return result ? `${result}` : '';

    } else 
    {
      return "";
    }
};


const formatInteger = (value) => {

  if (value != null && value !=="")
  {
        value = value.toString();
        // Remove all non-numeric characters except for the decimal point
        let result = value.replace(/[^0-9]/g, '');
      
        result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        
        return result ? `${result}` : '';

    } else 
    {
      return "";
    }
};

const NewContractorModal = ({ isOpen, onClose, onSave, contractor }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [maximized, setMaximized] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const { appUserAccountNumber } = useUser();

  const { applicationMode } = useApplicationMode(); 
  
  const [firstName, setFirstName] = useState('');
const [lastName, setLastName] = useState('');
const [gender, setGender] = useState('');
const [email, setEmail] = useState('');
const [phone, setPhone] = useState('');
const [address, setAddress] = useState('');
const [contractorID, setContractorID] = useState('');
const [contractDuration, setContractDuration] = useState('');
const [contractorCompanyId, setContractorCompanyId] = useState('');
const [contractorCompanies, setContractorCompanies] = useState([]);
const [hireDate, setHireDate] = useState('');
const [workDays, setWorkDays] = useState({
                    Monday: false,
Tuesday: false,
Wednesday: false,
Thursday: false,
Friday: false,
Saturday: false,
Sunday: false,
                  });
const [weekendAvailability, setWeekendAvailability] = useState('');
const [holidayAvailability, setHolidayAvailability] = useState('');
const [workScheduleStartTime, setWorkScheduleStartTime] = useState('');
const [workScheduleEndTime, setWorkScheduleEndTime] = useState('');
const [emergencyContactName, setEmergencyContactName] = useState('');
const [emergencyContactRelationship, setEmergencyContactRelationship] = useState('');
const [emergencyContactPhone, setEmergencyContactPhone] = useState('');
const [endDate, setEndDate] = useState('');
const [resume, setResume] = useState(null);
const [resumeFileName, setResumeFileName] = useState('');
const [specialization, setSpecialization] = useState('');
const [experienceYears, setExperienceYears] = useState('');
const [rating, setRating] = useState('');
const [skills, setSkills] = useState('');
const [notes, setNotes] = useState('');
const [hourlyRate, setHourlyRate] = useState('');
const [isActive, setIsActive] = useState('');


  const [validationErrors, setValidationErrors] = useState({});
  const [fontSize, setFontSize] = useState(14);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);

  const CustomPaper = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? colors.greenAccent[700] : colors.greenAccent[700],
  }));

  // Add state for password visibility
  const [showPassword, setShowPassword] = useState(false);

  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (isOpen) {
      if (contractor) {
        setFirstName(contractor.firstName);
setLastName(contractor.lastName);
setGender(contractor.gender);
setEmail(contractor.email);
setPhone(formatPhoneNumber(contractor.phone));
setAddress(contractor.address);
setContractorID(contractor.contractorID);
setContractDuration(contractor.contractDuration);
setContractorCompanyId(contractor.contractorCompanyId || '');
setHireDate(contractor.hireDate?new Date(contractor.hireDate.seconds * 1000).toISOString().slice(0, 10):'');
 setWorkDays({
                        Monday: contractor.workDays.includes('Monday'),
Tuesday: contractor.workDays.includes('Tuesday'),
Wednesday: contractor.workDays.includes('Wednesday'),
Thursday: contractor.workDays.includes('Thursday'),
Friday: contractor.workDays.includes('Friday'),
Saturday: contractor.workDays.includes('Saturday'),
Sunday: contractor.workDays.includes('Sunday'),
                        });
setWeekendAvailability(contractor.weekendAvailability);
setHolidayAvailability(contractor.holidayAvailability);
setWorkScheduleStartTime(convertFirestoreTimestampToTimeString(contractor.workScheduleStartTime));setWorkScheduleEndTime(convertFirestoreTimestampToTimeString(contractor.workScheduleEndTime));setEmergencyContactName(contractor.emergencyContactName);
setEmergencyContactRelationship(contractor.emergencyContactRelationship);
setEmergencyContactPhone(formatPhoneNumber(contractor.emergencyContactPhone));
setEndDate(contractor.endDate?new Date(contractor.endDate.seconds * 1000).toISOString().slice(0, 10):'');
setResume(contractor.resume || null);setResumeFileName(contractor.resumeFileName);
setSpecialization(contractor.specialization);
setExperienceYears(contractor.experienceYears);
setRating(contractor.rating);
setSkills(contractor.skills);
setNotes(contractor.notes);
setHourlyRate(formatCurrency(contractor.hourlyRate.toString()));
setIsActive(contractor.isActive);

       
      } else {
        setFirstName('');
setLastName('');
setGender('');
setEmail('');
setPhone('');
setAddress('');
setContractorID('');
setContractDuration('');
setContractorCompanyId('');
setHireDate('');
 setWorkDays({
                        Monday: false,
Tuesday: false,
Wednesday: false,
Thursday: false,
Friday: false,
Saturday: false,
Sunday: false,
                      });
setWeekendAvailability(false);
setHolidayAvailability(false);
setWorkScheduleStartTime('');
setWorkScheduleEndTime('');
setEmergencyContactName('');
setEmergencyContactRelationship('');
setEmergencyContactPhone('');
setEndDate('');
setResume(null);
setResumeFileName('');
setSpecialization('');
setExperienceYears(0);
setRating(0);
setSkills('');
setNotes('');
setHourlyRate(0);
setIsActive(false);

      }
      setValidationErrors({});
    }
  }, [isOpen, contractor]);

  
                useEffect(() => {
                    const fetchContractorCompanies = async () => {
                      const contractorCompaniesCollection = collection(db, 'contractorCompanies');
                      const q = query(contractorCompaniesCollection, where("appAccountNumber", "==", appUserAccountNumber), where("applicationMode", "==", applicationMode));
                      const contractorCompaniesSnapshot = await getDocs(q);
                      const contractorCompaniesData = contractorCompaniesSnapshot.docs.map(doc => ({
                        id: doc.id,
                        name: doc.data().name
                      }));
                      setContractorCompanies(contractorCompaniesData);
                    };
                
                    fetchContractorCompanies();
                  }, [appUserAccountNumber, applicationMode]);
                
                



  const increaseFontSize = () => {
    if (fontSize < 21) {
      setFontSize(fontSize + 1);
    }
  };

  const decreaseFontSize = () => {
    if (fontSize > 11) {
      setFontSize(fontSize - 1);
    }
  };

  const handleFieldChange = (setter, formatter) => (event) => {
    if (formatter != null) {
      setter(formatter(event.target.value));
    } else {
      setter(event.target.value);
    }
    setValidationErrors((prev) => ({ ...prev, [event.target.id]: false }));
  };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
    onClose();
  };

  const handleCancelClose = () => {
    setConfirmOpen(false);
  };

  ;
      
      
  const handleSave = () => {
    const errors = {};

    if (!firstName) errors.firstName = true;
if (!lastName) errors.lastName = true;
if (!email) errors.email = true;
if (!phone) errors.phone = true;
if (!contractorCompanyId) errors.contractorCompanyId = true;


    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setErrorDialogOpen(true);
      return;
    }

    const contractorEntry = {
      firstName,
lastName,
gender,
email,
phone:phone.replace(/[^\d]/g, ''),
address,
contractorID,
contractDuration,
contractorCompanyId,
hireDate:convertDateToFirestoreTimestamp(hireDate),
workDays: Object.keys(workDays).filter((key) => workDays[key]),
weekendAvailability,
holidayAvailability,
workScheduleStartTime:convertTimeStringToFirestoreTimestamp(workScheduleStartTime),
workScheduleEndTime:convertTimeStringToFirestoreTimestamp(workScheduleEndTime),
emergencyContactName,
emergencyContactRelationship,
emergencyContactPhone:emergencyContactPhone.replace(/[^\d]/g, ''),
endDate:convertDateToFirestoreTimestamp(endDate),
resume,
resumeFileName,
specialization,
experienceYears,
rating,
skills,
notes,
hourlyRate:hourlyRate? parseFloat(hourlyRate.replace(/[^0-9.]/g, '')) : 0,
isActive,
appAccountNumber:appUserAccountNumber,
applicationMode:applicationMode
    };

    if (contractor != null && contractor.id != null) {
      contractorEntry.id = contractor.id;
    }

    onSave(contractorEntry);
    onClose();
  };

   const handleResumeFileChange = (event) => {
                    const file = event.target.files[0];
                    if (file) {
                    const reader = new FileReader();
                    reader.onload = () => {

                      let existingFilesTotalSize = getExistingFileTotalSize();
                      const nextTotalSize = existingFilesTotalSize + reader.result.length;

                      if (nextTotalSize < 1048487)
                      {
                        setResume(reader.result);
                        setResumeFileName(file.name);
                      } else
                      {
                        alert("The "+file.name+" file cannot be added because it would cause the total attached file size for the record to exceed the maximum allowed size of 1,048,576 bytes");
                      }
                    };
                    reader.readAsDataURL(file);
                    }

                    // Clear the input
                    event.target.value = '';
                };

                   const handleRemoveResumeImage = () => {
                    setResume(null);
                    setResumeFileName(null);
                };

                


  
     const getExistingFileTotalSize = () => {

       let existingFilesTotalSize = 0;

    


             if (resume != null)
             {
               existingFilesTotalSize += resume.length;
             }

            

    
      return existingFilesTotalSize;
    }

   

  
  const stringToColorLight = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      // Ensuring that the color values are always light by adding a base value of 127
      const lightValue = ((value + 127) % 128) + 127;
      color += ('00' + lightValue.toString(16)).substr(-2);
    }
    return color;
  };
  
  const stringToColorDark = (str) => {
  
    return stringToColorLight(str); // We will use the same colors
  };
  
  const stringToColorDarkOLD = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      // Ensuring that the color values are always dark by restricting them to the first half of 256
      const darkValue = value % 128;
      color += ('00' + darkValue.toString(16)).substr(-2);
    }
    return color;
  };
  

  
  const convertDateToFirestoreTimestamp = (dateString) => {

    if (dateString !== "" && dateString != null)
    {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          throw new Error("Invalid date format. Please use mm/dd/yyyy format.");
        }
        const seconds = Math.floor(date.getTime() / 1000);
        const nanoseconds = 0;
        return {
          seconds: seconds,
          nanoseconds: nanoseconds
        };
    } else 
    {
      return null;
    }
  };

  const convertTimeStringToFirestoreTimestamp = (timeString) => {

    if (timeString !== "" && timeString != null)
    {
        // Get the current date
        const now = new Date();
      
        // Extract hours and minutes from the time string
        const [hours, minutes] = timeString.split(':').map(Number);
      
        // Validate the time string
        if (isNaN(hours) || isNaN(minutes) || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
          throw new Error("Invalid time format. Please use HH:mm format.");
        }
      
        // Set the hours and minutes on the current date
        now.setHours(hours);
        now.setMinutes(minutes);
        now.setSeconds(0);
        now.setMilliseconds(0);
      
        // Convert the Date object to seconds since Unix epoch
        const seconds = Math.floor(now.getTime() / 1000);
        const nanoseconds = 0;
      
        // Return the Firestore-like timestamp object
        return {
          seconds: seconds,
          nanoseconds: nanoseconds
        };
    } else 
    {
      return null;
    }
  };
  
  const convertFirestoreTimestampToTimeString = (timestamp) => {

    if (timestamp != null && timestamp !=="")
    {
        // Convert the seconds since Unix epoch to a Date object
        const date = new Date(timestamp.seconds * 1000);
      
        // Extract hours and minutes
        const hours = date.getHours();
        const minutes = date.getMinutes();
      
        // Format hours and minutes as a time string in "HH:mm" format
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
      
        return `${formattedHours}:${formattedMinutes}`;
    } else 
    {
      return "";
    }
  };


  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
  };

  const handleFileClick = (fileType,fileContent,fileName) => {
    if (fileType === 'pdf') {
      
      const base64String = fileContent.split(',')[1]; // Extract base64 string from data URL
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
  
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
  
      window.open(blobUrl, '_blank');

    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      const image = new Image();
      image.src = fileContent;
    
      image.onload = () => {
        let width = image.naturalWidth;
        let height = image.naturalHeight;
        const padding = 50;
    
        // Get browser window dimensions
        const maxWidth = window.innerWidth - padding;
        const maxHeight = window.innerHeight - padding;
    
        // Resize the image if it's larger than the browser window
        if (width > maxWidth || height > maxHeight) {
          const widthRatio = maxWidth / width;
          const heightRatio = maxHeight / height;
          const minRatio = Math.min(widthRatio, heightRatio);
    
          width = Math.floor(width * minRatio);
          height = Math.floor(height * minRatio);
        }
    
        // Calculate the position to center the window
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
    
        // Open the window with the calculated position and size
        const w = window.open("", "", `width=${width + padding},height=${height + padding},left=${left},top=${top}`);
        image.style.width = `${width}px`;
        image.style.height = `${height}px`;
        w.document.write(image.outerHTML);
      };
        
    } else {
      const link = document.createElement('a');
      link.href = fileContent;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  
  const renderFileSize = (base64String) => {

    if (base64String != null)
    {
      const sizeInBytes = base64String.length * (3 / 4) - (base64String.indexOf('=') > 0 ? base64String.split('=').length - 1 : 0);
      const sizeInKB = sizeInBytes / 1024;
      const sizeInMB = sizeInKB / 1024;
    
      if (sizeInMB >= 1) {
        return <div style={{textAlign:'center'}}>{sizeInMB.toFixed(2)} MB</div>//`${sizeInMB.toFixed(2)} MB`;
      } else {
        return <div style={{textAlign:'center'}}>{sizeInKB.toFixed(2)} KB</div> //`${sizeInKB.toFixed(2)} KB`;
      }
    } else
    {
      return <div></div>;
    }
  };
  
  const renderThumbnail = (fileContent,fileName) => {
    if (!fileContent || !fileName) return null;
    const fileType = getFileExtension(fileName);
    if (fileType === 'pdf') {
      return <img src={PdfThumbnail} title={fileName} alt="PDF thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'81px' }} />;
    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      return <img src={fileContent} title={fileName} alt="Profile thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer', maxWidth: '100px', maxHeight: '100px' }} />;
    } else {
      return <img src={GenericFileThumbnail} title={fileName} alt="File thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'77px'  }} />;
    }
  };

  const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
  
  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => setConfirmOpen(true)}
        fullScreen={maximized}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: colors.inputModal.dialogHeaderBackgroundColor }}>
        <Box sx={{ color: (theme) => theme.palette.grey[100] }}>
            {contractor ? "Edit Contractor : " +contractor.id : "Add New Contractor"}
          </Box>
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <IconButton aria-label="decrease font size" onClick={decreaseFontSize} sx={{ marginRight: 1, color: (theme) => theme.palette.grey[500] }}>
              <RemoveIcon />
            </IconButton>
            <IconButton aria-label="increase font size" onClick={increaseFontSize} sx={{ color: (theme) => theme.palette.grey[500] }}>
              <AddIcon />
            </IconButton>
          </Box>
          <Box>
            <IconButton
              aria-label={maximized ? "exit full screen" : "full screen"}
              onClick={() => setMaximized(!maximized)}
              sx={{ color: (theme) => theme.palette.grey[500] }}
            >
              {maximized ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </IconButton>
            <IconButton
              aria-label="close"
              onClick={() => setConfirmOpen(true)}
              sx={{ color: (theme) => theme.palette.grey[500] }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ backgroundColor: colors.inputModal.dialogContentBackgroundColor }}>
          <FormGroup>
            <Grid container spacing={2}>
            
            <Grid item xs={12} md={6}>

<TextField fullWidth margin="normal" id="firstName" label="First Name"  value={firstName} onChange={handleFieldChange(setFirstName)} error={validationErrors.firstName}  inputProps={{ style: { fontSize }}} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor,
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>
<TextField fullWidth margin="normal" id="lastName" label="Last Name"  value={lastName} onChange={handleFieldChange(setLastName)} error={validationErrors.lastName}  inputProps={{ style: { fontSize }}} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor,
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>

                <Autocomplete
                fullWidth
                margin="normal"
                options={[
                  "Male","Female","Other"
                ]}
                renderInput={(params) => (
                  <TextField {...params} label="Gender" margin="normal"   inputProps={{ ...params.inputProps, style: { fontSize } }} />
                )}
                PaperComponent={CustomPaper}
                value={gender}
                onChange={(event, newValue) => setGender(newValue)} 
                sx={{'& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor,
                    '& fieldset': {
                        borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                        borderColor: colors.inputModal.inputHoverBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                        },
                    '&.Mui-focused fieldset': {
                        borderColor: colors.inputModal.inputFocusedBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                        },},
                    '& .MuiInputLabel-root': {
                        color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                        color: colors.inputModal.inputHoverBorderColor,},
                    '&.Mui-focused': {
                        color: 'currentColor',},},}}
              />
                
<TextField fullWidth margin="normal" id="email" label="Email"  value={email} onChange={handleFieldChange(setEmail)} error={validationErrors.email}  inputProps={{ style: { fontSize }}} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor,
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>
<TextField fullWidth margin="normal" id="phone" label="Phone Number"  value={phone} onChange={handleFieldChange(setPhone, formatPhoneNumber)} error={validationErrors.phone}  inputProps={{ style: { fontSize }}} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor,
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>
<TextField fullWidth margin="normal" id="address" label="Address"  value={address} onChange={handleFieldChange(setAddress)}  inputProps={{ style: { fontSize } }} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor, 
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
        
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>
<TextField fullWidth margin="normal" id="contractorID" label="Contractor ID"  value={contractorID} onChange={handleFieldChange(setContractorID)}  inputProps={{ style: { fontSize } }} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor, 
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
        
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>

                <Autocomplete
                fullWidth
                margin="normal"
                options={[
                  "Three Months","Six Months","Eight Months","Twelve Months","Eighteen Months","Other"
                ]}
                renderInput={(params) => (
                  <TextField {...params} label="Contract Duration" margin="normal"   inputProps={{ ...params.inputProps, style: { fontSize } }} />
                )}
                PaperComponent={CustomPaper}
                value={contractDuration}
                onChange={(event, newValue) => setContractDuration(newValue)} 
                sx={{'& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor,
                    '& fieldset': {
                        borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                        borderColor: colors.inputModal.inputHoverBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                        },
                    '&.Mui-focused fieldset': {
                        borderColor: colors.inputModal.inputFocusedBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                        },},
                    '& .MuiInputLabel-root': {
                        color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                        color: colors.inputModal.inputHoverBorderColor,},
                    '&.Mui-focused': {
                        color: 'currentColor',},},}}
              />
                
<Autocomplete
                fullWidth
                margin="normal" 
                options={contractorCompanies}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField {...params} label="Contractor Company"   error={validationErrors.contractorCompanyId}  margin="normal" inputProps={{ ...params.inputProps, style: { fontSize } }} />
                )}
                PaperComponent={CustomPaper}
                value={contractorCompanies.find(ref => ref.id === contractorCompanyId) || null}
                onChange={(event, newValue) => setContractorCompanyId(newValue ? newValue.id : '')}
                sx={{'& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor,
                    '& fieldset': {
                        borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                        borderColor: colors.inputModal.inputHoverBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                        },
                    '&.Mui-focused fieldset': {
                        borderColor: colors.inputModal.inputFocusedBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                        },},
                    '& .MuiInputLabel-root': {
                        color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                        color: colors.inputModal.inputHoverBorderColor,},
                    '&.Mui-focused': {
                        color: 'currentColor',},},}}
              />
</Grid>

<Grid item xs={12} md={6}>


                <TextField
                fullWidth
                margin="normal"
                id="hireDate"
                label="Hire Date"
                type="date" 
                InputLabelProps={{ shrink: true, style: { fontSize } }}
                value={hireDate}
                onChange={e => setHireDate(e.target.value)} 
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: colors.inputModal.inputBackgroundColor, 
                    '& fieldset': {borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                      borderColor: colors.inputModal.inputHoverBorderColor,
                      ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: colors.inputModal.inputFocusedBorderColor,
                      ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                      color: colors.inputModal.inputHoverBorderColor,
                    },
                    '&.Mui-focused': {
                      color: 'currentColor',
                    },
                  },
                  '& .MuiSvgIcon-root': {
                    color: theme.palette.mode === 'dark' ? colors.greenAccent[600] : colors.greenAccent[400],
                  },
                  '& input::-webkit-calendar-picker-indicator': {
                    filter: theme.palette.mode === 'dark' ? 'invert(35%) sepia(63%) saturate(3186%) hue-rotate(110deg) brightness(90%) contrast(92%)' : 'invert(46%) sepia(83%) saturate(748%) hue-rotate(87deg) brightness(93%) contrast(90%)',
                  },
                }}
             />
                

                    <TextField
                    fullWidth
                    margin="normal"
                    id="workScheduleStartTime"
                    label="work Schedule Start Time"
                    type="time" 
                    InputLabelProps={{ shrink: true, style: { fontSize } }}
                    value={workScheduleStartTime}
                    onChange={e => setWorkScheduleStartTime(e.target.value)} 
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor, 
                        '& fieldset': {borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                          borderColor: colors.inputModal.inputHoverBorderColor,
                          ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: colors.inputModal.inputFocusedBorderColor,
                          ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
                        },
                      },
                      '& .MuiInputLabel-root': {
                      color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                          color: colors.inputModal.inputHoverBorderColor,
                        },
                        '&.Mui-focused': {
                          color: 'currentColor',
                        },
                      },
                      '& .MuiSvgIcon-root': {
                        color: theme.palette.mode === 'dark' ? colors.greenAccent[600] : colors.greenAccent[400],
                      },
                      '& input::-webkit-calendar-picker-indicator': {
                        filter: theme.palette.mode === 'dark' ? 'invert(35%) sepia(63%) saturate(3186%) hue-rotate(110deg) brightness(90%) contrast(92%)' : 'invert(46%) sepia(83%) saturate(748%) hue-rotate(87deg) brightness(93%) contrast(90%)',
                      },
                    }}
                 />
                    

                    <TextField
                    fullWidth
                    margin="normal"
                    id="workScheduleEndTime"
                    label="work Schedule End Time"
                    type="time" 
                    InputLabelProps={{ shrink: true, style: { fontSize } }}
                    value={workScheduleEndTime}
                    onChange={e => setWorkScheduleEndTime(e.target.value)} 
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor, 
                        '& fieldset': {borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                          borderColor: colors.inputModal.inputHoverBorderColor,
                          ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: colors.inputModal.inputFocusedBorderColor,
                          ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
                        },
                      },
                      '& .MuiInputLabel-root': {
                      color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                          color: colors.inputModal.inputHoverBorderColor,
                        },
                        '&.Mui-focused': {
                          color: 'currentColor',
                        },
                      },
                      '& .MuiSvgIcon-root': {
                        color: theme.palette.mode === 'dark' ? colors.greenAccent[600] : colors.greenAccent[400],
                      },
                      '& input::-webkit-calendar-picker-indicator': {
                        filter: theme.palette.mode === 'dark' ? 'invert(35%) sepia(63%) saturate(3186%) hue-rotate(110deg) brightness(90%) contrast(92%)' : 'invert(46%) sepia(83%) saturate(748%) hue-rotate(87deg) brightness(93%) contrast(90%)',
                      },
                    }}
                 />
                    
<TextField fullWidth margin="normal" id="emergencyContactName" label="Emergency Contact Name"  value={emergencyContactName} onChange={handleFieldChange(setEmergencyContactName)}  inputProps={{ style: { fontSize } }} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor, 
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
        
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>
<TextField fullWidth margin="normal" id="emergencyContactRelationship" label="Emergency Contact Relationship"  value={emergencyContactRelationship} onChange={handleFieldChange(setEmergencyContactRelationship)}  inputProps={{ style: { fontSize } }} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor, 
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
        
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>
<TextField fullWidth margin="normal" id="emergencyContactPhone" label="Emergency Contact Phone"  value={emergencyContactPhone} onChange={handleFieldChange(setEmergencyContactPhone, formatPhoneNumber)}  inputProps={{ style: { fontSize } }} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor, 
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
        
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>

                <TextField
                fullWidth
                margin="normal"
                id="endDate"
                label="End Date"
                type="date" 
                InputLabelProps={{ shrink: true, style: { fontSize } }}
                value={endDate}
                onChange={e => setEndDate(e.target.value)} 
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: colors.inputModal.inputBackgroundColor, 
                    '& fieldset': {borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                      borderColor: colors.inputModal.inputHoverBorderColor,
                      ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: colors.inputModal.inputFocusedBorderColor,
                      ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                      color: colors.inputModal.inputHoverBorderColor,
                    },
                    '&.Mui-focused': {
                      color: 'currentColor',
                    },
                  },
                  '& .MuiSvgIcon-root': {
                    color: theme.palette.mode === 'dark' ? colors.greenAccent[600] : colors.greenAccent[400],
                  },
                  '& input::-webkit-calendar-picker-indicator': {
                    filter: theme.palette.mode === 'dark' ? 'invert(35%) sepia(63%) saturate(3186%) hue-rotate(110deg) brightness(90%) contrast(92%)' : 'invert(46%) sepia(83%) saturate(748%) hue-rotate(87deg) brightness(93%) contrast(90%)',
                  },
                }}
             />
                
<TextField fullWidth margin="normal" id="specialization" label="Specialization"  value={specialization} onChange={handleFieldChange(setSpecialization)}  inputProps={{ style: { fontSize } }} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor, 
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
        
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>
<TextField fullWidth margin="normal" id="hourlyRate" label="Hourly Rate"  value={hourlyRate} onChange={handleFieldChange(setHourlyRate, formatCurrency)}  inputProps={{ style: { fontSize } }} 
                    sx={{'& .MuiOutlinedInput-root': {
                            backgroundColor: colors.inputModal.inputBackgroundColor, 
                        '& fieldset': {
                            borderColor: colors.inputModal.inputDefaultBorderColor}, 
                        '&:hover fieldset': {
                            borderColor: colors.inputModal.inputHoverBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                            }),
                            },
                        '&.Mui-focused fieldset': {
                            borderColor: colors.inputModal.inputFocusedBorderColor,
                            ...(theme.palette.mode !== 'dark' && {
                                boxShadow: '0 0 3px 1px blue',
                            }),
        
                            },},
                        '& .MuiInputLabel-root': {
                            color:colors.inputModal.inputDefaultBorderColor, 
                        '&:hover': {
                            color: colors.inputModal.inputHoverBorderColor,},
                        '&.Mui-focused': {
                            color: 'currentColor',},},}}/>


                    
                    <Slider
                        value={parseFloat(hourlyRate.toString().replace(/[^0-9.]/g, '')) || 0}
                        onChange={(e, newValue) => setHourlyRate(formatCurrency(newValue.toString()))}
                        min={15}
                        max={200}
                        step={5}
                        valueLabelDisplay="auto"
                        sx={{ marginY: 1, marginLeft:'5px', paddingTop :'0px',marginTop :'0px',color: colors.inputModal.inputDefaultBorderColor }}
                        />
                    
                        

                    </Grid>


            
            </Grid>
              
            
                    <FormControl component="fieldset" margin="normal">
                        <FormLabel component="legend">Work Days</FormLabel>
                        <MuiFormGroup row>
                    
                

                    <FormControlLabel
                        control={<Checkbox checked={workDays.Monday} onChange={(e) => setWorkDays({ ...workDays, Monday: e.target.checked })} sx={{color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],'&.Mui-checked': {color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],},}} />}
                        label="Monday"
                    />

                    

                    <FormControlLabel
                        control={<Checkbox checked={workDays.Tuesday} onChange={(e) => setWorkDays({ ...workDays, Tuesday: e.target.checked })} sx={{color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],'&.Mui-checked': {color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],},}} />}
                        label="Tuesday"
                    />

                    

                    <FormControlLabel
                        control={<Checkbox checked={workDays.Wednesday} onChange={(e) => setWorkDays({ ...workDays, Wednesday: e.target.checked })} sx={{color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],'&.Mui-checked': {color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],},}} />}
                        label="Wednesday"
                    />

                    

                    <FormControlLabel
                        control={<Checkbox checked={workDays.Thursday} onChange={(e) => setWorkDays({ ...workDays, Thursday: e.target.checked })} sx={{color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],'&.Mui-checked': {color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],},}} />}
                        label="Thursday"
                    />

                    

                    <FormControlLabel
                        control={<Checkbox checked={workDays.Friday} onChange={(e) => setWorkDays({ ...workDays, Friday: e.target.checked })} sx={{color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],'&.Mui-checked': {color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],},}} />}
                        label="Friday"
                    />

                    

                    <FormControlLabel
                        control={<Checkbox checked={workDays.Saturday} onChange={(e) => setWorkDays({ ...workDays, Saturday: e.target.checked })} sx={{color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],'&.Mui-checked': {color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],},}} />}
                        label="Saturday"
                    />

                    

                    <FormControlLabel
                        control={<Checkbox checked={workDays.Sunday} onChange={(e) => setWorkDays({ ...workDays, Sunday: e.target.checked })} sx={{color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],'&.Mui-checked': {color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],},}} />}
                        label="Sunday"
                    />

                    

                    </MuiFormGroup>
                </FormControl>
                

                <FormControlLabel
                    control={<Switch checked={weekendAvailability} onChange={(e) => setWeekendAvailability(e.target.checked)} 
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                        '&:hover': {
                            backgroundColor: 'rgba(0, 128, 0, 0.1)',
                        },
                        },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                        },
                    }}
                    />}
                    label="Weekend Availability"
                    />
                

                <FormControlLabel
                    control={<Switch checked={holidayAvailability} onChange={(e) => setHolidayAvailability(e.target.checked)} 
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                        '&:hover': {
                            backgroundColor: 'rgba(0, 128, 0, 0.1)',
                        },
                        },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                        },
                    }}
                    />}
                    label="Holiday Availability"
                    />
                

                        <FormControl component="fieldset" margin="normal">
              <FormLabel component="legend">Resume</FormLabel>
              <input type="file" accept=".*" onChange={handleResumeFileChange} />

              <div style={{ maxWidth:'100px', width:'100px', position: 'relative'}}> 
              <div>{resumeFileName}</div>
              {renderThumbnail(resume,resumeFileName)}

              {renderFileSize(resume)}

              {resume && ( 
              <IconButton
                    size="small"
                    style={{ position: 'absolute', top: 20, right: 5, color: 'red' }}
                    onClick={() => handleRemoveResumeImage()}
                    >
                    <DeleteIcon />
                    </IconButton>
               )}
              </div>
            </FormControl>
                        

                <FormControl component="fieldset" margin="normal" 
                error={validationErrors.experienceYears} // Pass the validation error state
                        sx={{
                                border: validationErrors.experienceYears ? '1px solid #c70101' : 'none',
                                borderRadius: '4px',
                                padding: '8px',
                                '&:hover': {
                                    borderColor: colors.inputModal.inputHoverBorderColor,
                                },
                                '&.Mui-focused': {
                                    borderColor: colors.inputModal.inputFocusedBorderColor,
                                },
                            
                        }}
                >
                <Typography id="experienceYears-slider" gutterBottom>
                  Experience Years
                </Typography>
                <Slider
                  value={experienceYears}
                  onChange={(e, newValue) => setExperienceYears(newValue)}
                  valueLabelDisplay="auto"
                  aria-labelledby="experienceYears-slider"
                  min={0}
                  max={50}
                  sx={{
                    color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                    width:'50%'
                  }}
                />
              </FormControl>
         
                

                <FormControl component="fieldset" margin="normal" 
                error={validationErrors.rating} // Pass the validation error state
                        sx={{
                                border: validationErrors.rating ? '1px solid #c70101' : 'none',
                                borderRadius: '4px',
                                padding: '8px',
                                '&:hover': {
                                    borderColor: colors.inputModal.inputHoverBorderColor,
                                },
                                '&.Mui-focused': {
                                    borderColor: colors.inputModal.inputFocusedBorderColor,
                                },
                            
                        }}
                >
                <Typography id="rating-slider" gutterBottom>
                  Rating
                </Typography>
                <Slider
                  value={rating}
                  onChange={(e, newValue) => setRating(newValue)}
                  valueLabelDisplay="auto"
                  aria-labelledby="rating-slider"
                  min={0}
                  max={5}
                  sx={{
                    color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                    width:'50%'
                  }}
                />
              </FormControl>
         
                

                <TextField
                fullWidth
                margin="normal"
                id="skills" 
                error={validationErrors.skills} 
                label="Skills/Certifications"
                multiline
                rows={4}
                value={skills}
                onChange={handleFieldChange(setSkills)}
                inputProps={{ style: { fontSize } }} 
                sx={{'& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor,
                    '& fieldset': {
                        borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                        borderColor: colors.inputModal.inputHoverBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                        },
                    '&.Mui-focused fieldset': {
                        borderColor: colors.inputModal.inputFocusedBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                        },},
                    '& .MuiInputLabel-root': {
                        color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                        color: colors.inputModal.inputHoverBorderColor,},
                    '&.Mui-focused': {
                        color: 'currentColor',},},}}
                />
                    

                <TextField
                fullWidth
                margin="normal"
                id="notes" 
                error={validationErrors.notes} 
                label="Notes"
                multiline
                rows={4}
                value={notes}
                onChange={handleFieldChange(setNotes)}
                inputProps={{ style: { fontSize } }} 
                sx={{'& .MuiOutlinedInput-root': {
                        backgroundColor: colors.inputModal.inputBackgroundColor,
                    '& fieldset': {
                        borderColor: colors.inputModal.inputDefaultBorderColor}, 
                    '&:hover fieldset': {
                        borderColor: colors.inputModal.inputHoverBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)',
                        }),
                        },
                    '&.Mui-focused fieldset': {
                        borderColor: colors.inputModal.inputFocusedBorderColor,
                        ...(theme.palette.mode !== 'dark' && {
                            boxShadow: '0 0 3px 1px blue',
                        }),
                        },},
                    '& .MuiInputLabel-root': {
                        color:colors.inputModal.inputDefaultBorderColor, 
                    '&:hover': {
                        color: colors.inputModal.inputHoverBorderColor,},
                    '&.Mui-focused': {
                        color: 'currentColor',},},}}
                />
                    

                <FormControlLabel
                    control={<Switch checked={isActive} onChange={(e) => setIsActive(e.target.checked)} 
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                        '&:hover': {
                            backgroundColor: 'rgba(0, 128, 0, 0.1)',
                        },
                        },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                        },
                    }}
                    />}
                    label="Active"
                    />
                


          </FormGroup>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button variant="contained" onClick={handleSave} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>Save</Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={confirmOpen}
        onClose={handleCancelClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            Sure you want to close without saving changes?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
            No
          </Button>
          <Button onClick={handleConfirmClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={errorDialogOpen}
        onClose={() => setErrorDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Validation Error"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            Please fill all required fields.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={() => setErrorDialogOpen(false)} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewContractorModal;
